import { type IconProp } from '@atlaskit/button/new';

import { SlackIcon, TeamsIcon } from '../components/icons/ThirdPartyMessageProductIcons';

import { type ExternalMessageDmIntegrationInfo } from './thirdPartyMessaging';

export const EXTERNAL_MESSAGE_INTEGRATION_ICONS: Record<
	ExternalMessageDmIntegrationInfo['integration'],
	IconProp
> = {
	slack: SlackIcon as IconProp,
	'ms-teams': TeamsIcon as IconProp,
};

export function getIconForExternalMessageIntegration(
	integration: ExternalMessageDmIntegrationInfo['integration'],
): IconProp {
	return EXTERNAL_MESSAGE_INTEGRATION_ICONS[integration];
}
